// @flow
export default function indent(amount: number = 1): string {
  return ' '.repeat(amount);
}
